// Membership tab (MingZe only): member list, details, edit, CSV export, register QR poster.
import React from "react";
import QRCode from "qrcode.react";
import ReactToPrint from "react-to-print";
import {
  Alert, Badge, Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner, Table,
} from "reactstrap";
import { PageShell, StatusBadge } from "./memberComponents.jsx";
import { currentBranch, formatDate, formatPhone, isOwner, memberPost, registerUrl } from "./memberApi.js";

const csvCell = (v) => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"';

class QrPoster extends React.Component {
  render() {
    const url = registerUrl(this.props.branch);
    return (
      <div style={{ textAlign: 'center', padding: 40, fontFamily: 'Arial, sans-serif' }}>
        <img src={require("assets/img/brand/mzprotradainglogo.png")} alt="" style={{ maxWidth: 220, maxHeight: 100 }} />
        <h1 style={{ fontSize: 40, margin: '24px 0 8px' }}>Become a Member</h1>
        <h2 style={{ fontSize: 26, margin: 0, fontWeight: 400 }}>成为会员 · Jadi Ahli</h2>
        <div style={{ margin: '32px auto', display: 'inline-block', padding: 16, border: '4px solid #172b4d', borderRadius: 16 }}>
          <QRCode value={url} size={320} level="M" renderAs="svg" />
        </div>
        <p style={{ fontSize: 22, margin: 0 }}>Scan to register for FREE</p>
        <p style={{ fontSize: 18, color: '#525f7f' }}>扫码免费注册 · Imbas untuk daftar PERCUMA</p>
        <p style={{ fontSize: 14, color: '#8898aa', marginTop: 24 }}>MZ Pro Trading {this.props.branch}<br />{url}</p>
      </div>
    );
  }
}

class Membership extends React.Component {
  state = { members: [], branches: [], loading: true, error: '', search: '', edit: null, saving: false, editerror: '', showqr: false };

  componentDidMount() { if (isOwner()) this.load(); }

  load = () => {
    this.setState({ loading: true });
    memberPost('member-list').then(json => this.setState({
      loading: false, members: json.success == 1 ? json.members : [], branches: json.success == 1 ? json.branches : [], error: json.success == 1 ? '' : json.message,
    }));
  };

  filtered() {
    const term = this.state.search.trim().toLowerCase();
    if (!term) return this.state.members;
    return this.state.members.filter(m =>
      [m.memberid, m.name, m.phone, m.email, m.icnumber].join(' ').toLowerCase().indexOf(term) !== -1);
  }

  exportCsv = () => {
    const header = ['Member ID', 'Branch', 'Name', 'Phone', 'IC', 'Email', 'Birthday', 'Gender', 'Address', 'Postcode', 'Email Consent', 'WhatsApp Consent', 'Status', 'Registered'];
    const lines = [header.map(csvCell).join(',')].concat(this.filtered().map(m => [
      m.memberid, m.server, m.name, "'" + m.phone, "'" + m.icnumber, m.email, m.birthday, m.gender, m.address, m.postcode,
      m.emailconsent == 1 ? 'Yes' : 'No', m.whatsappconsent == 1 ? 'Yes' : 'No', m.status, formatDate(m.dateCreate),
    ].map(csvCell).join(',')));
    const blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'members_' + new Date().toISOString().slice(0, 10) + '.csv';
    a.click();
  };

  openEdit = (m) => this.setState({ edit: Object.assign({}, m), editerror: '' });
  setEdit = (key, value) => this.setState({ edit: Object.assign({}, this.state.edit, { [key]: value }) });

  save = () => {
    const e = this.state.edit;
    this.setState({ saving: true, editerror: '' });
    memberPost('member-update', {
      memberid: e.memberid, name: e.name, phone: e.phone, icnumber: e.icnumber, email: e.email, birthday: e.birthday || '',
      gender: e.gender, address: e.address, postcode: e.postcode, emailconsent: e.emailconsent == 1 ? '1' : '0',
      whatsappconsent: e.whatsappconsent == 1 ? '1' : '0', status: e.status, remark: e.remark, server: e.server,
    }).then(json => {
      if (json.success == 1) { this.setState({ saving: false, edit: null }); this.load(); }
      else this.setState({ saving: false, editerror: json.message });
    });
  };

  renderEdit() {
    const e = this.state.edit;
    const field = (key, label, type = 'text', md = 6) => (
      <Col md={md}><FormGroup><Label className="form-control-label">{label}</Label>
        <Input type={type} value={e[key] || ''} onChange={ev => this.setEdit(key, ev.target.value)} /></FormGroup></Col>
    );
    return (
      <Modal isOpen={!!e} toggle={() => this.setState({ edit: null })} size="lg">
        <ModalHeader toggle={() => this.setState({ edit: null })}>Member {e.memberid}</ModalHeader>
        <ModalBody>
          <Row>
            {field('name', 'Name')}
            {field('phone', 'Phone (with country code, e.g. 60123456789)')}
            {field('icnumber', 'IC / Passport')}
            {field('email', 'Email', 'email')}
            {field('birthday', 'Birthday', 'date')}
            <Col md="6"><FormGroup><Label className="form-control-label">Gender</Label>
              <Input type="select" value={e.gender} onChange={ev => this.setEdit('gender', ev.target.value)}>
                <option value="">-</option><option>Male</option><option>Female</option>
              </Input></FormGroup></Col>
            {field('address', 'Address', 'text', 8)}
            {field('postcode', 'Postcode', 'text', 4)}
            <Col md="4"><FormGroup><Label className="form-control-label">Branch</Label>
              <Input type="select" value={e.server} onChange={ev => this.setEdit('server', ev.target.value)}>
                {e.server === '' ? <option value="">-- not assigned --</option> : null}
                {this.state.branches.map(b => <option key={b} value={b}>{b}</option>)}
              </Input></FormGroup></Col>
            <Col md="4"><FormGroup><Label className="form-control-label">Status</Label>
              <Input type="select" value={e.status} onChange={ev => this.setEdit('status', ev.target.value)}>
                <option>Active</option><option>Inactive</option>
              </Input></FormGroup></Col>
            <Col md="4" className="pt-md-4">
              <FormGroup check inline><Label check><Input type="checkbox" checked={e.whatsappconsent == 1} onChange={ev => this.setEdit('whatsappconsent', ev.target.checked ? 1 : 0)} /> Receive WhatsApp</Label></FormGroup>
              <FormGroup check inline><Label check><Input type="checkbox" checked={e.emailconsent == 1} onChange={ev => this.setEdit('emailconsent', ev.target.checked ? 1 : 0)} /> Receive Email</Label></FormGroup>
            </Col>
            {field('remark', 'Remark', 'text', 12)}
          </Row>
          <small className="text-muted">Registered {formatDate(e.dateCreate)} via {e.source}</small>
          {this.state.editerror ? <Alert color="danger" className="mt-2 py-2">{this.state.editerror}</Alert> : null}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => this.setState({ edit: null })}>Cancel</Button>
          <Button color="primary" onClick={this.save} disabled={this.state.saving}>{this.state.saving ? <Spinner size="sm" /> : 'Save'}</Button>
        </ModalFooter>
      </Modal>
    );
  }

  render() {
    const list = this.filtered();
    const unassigned = this.state.members.filter(m => !m.server).length;
    const actions = (
      <>
        <Button size="sm" color="info" onClick={() => this.setState({ showqr: true })}>Register QR Code</Button>
        <Button size="sm" color="success" onClick={this.exportCsv}>Export CSV</Button>
        <Button size="sm" color="secondary" onClick={this.load}>Refresh</Button>
      </>
    );
    return (
      <PageShell title="Membership" ownerOnly actions={actions}>
        <Row className="mb-3 align-items-center">
          <Col md="6"><Input placeholder="Search member ID, name, phone, email, IC" value={this.state.search} onChange={e => this.setState({ search: e.target.value })} /></Col>
          <Col md="6" className="text-md-right mt-2 mt-md-0"><strong>{list.length}</strong> of {this.state.members.length} members</Col>
        </Row>
        {this.state.error ? <Alert color="danger">{this.state.error}</Alert> : null}
        {unassigned > 0 ? (
          <Alert color="warning">
            <strong>{unassigned}</strong> member(s) have no branch yet (no purchase found). They join a branch automatically on their first purchase, or open <b>View / Edit</b> and choose a Branch. Until then they are left out of blasts and birthday messages.
          </Alert>
        ) : null}
        <Table size="sm" responsive hover className="align-items-center">
          <thead className="thead-light">
            <tr><th>Member ID</th><th>Branch</th><th>Name</th><th>Phone</th><th>Email</th><th>Birthday</th><th>WhatsApp / Email</th><th>Status</th><th>Registered</th><th></th></tr>
          </thead>
          <tbody>
            {this.state.loading ? <tr><td colSpan="10" className="text-center py-4"><Spinner /></td></tr> :
              list.length === 0 ? <tr><td colSpan="10" className="text-center text-muted py-4">No members</td></tr> :
                list.map(m => (
                  <tr key={m.memberid}>
                    <td><strong>{m.memberid}</strong></td>
                    <td>{m.server || <Badge color="warning">Not assigned</Badge>}</td>
                    <td>{m.name}</td>
                    <td>{formatPhone(m.phone)}</td>
                    <td>{m.email}</td>
                    <td>{m.birthday ? m.birthday.split('-').reverse().join('/') : '-'}</td>
                    <td>{m.whatsappconsent == 1 ? '✅' : '❌'} / {m.emailconsent == 1 ? '✅' : '❌'}</td>
                    <td><StatusBadge status={m.status} /></td>
                    <td>{formatDate(m.dateCreate)}</td>
                    <td><Button size="sm" color="primary" onClick={() => this.openEdit(m)}>View / Edit</Button></td>
                  </tr>
                ))}
          </tbody>
        </Table>

        {this.state.edit ? this.renderEdit() : null}

        <Modal isOpen={this.state.showqr} toggle={() => this.setState({ showqr: false })} size="lg">
          <ModalHeader toggle={() => this.setState({ showqr: false })}>Member Register QR Code ({currentBranch()})</ModalHeader>
          <ModalBody>
            <QrPoster ref={el => (this.poster = el)} branch={currentBranch()} />
          </ModalBody>
          <ModalFooter>
            <a href={registerUrl(currentBranch())} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">Open register page</a>
            <ReactToPrint trigger={() => <Button color="primary">Print poster</Button>} content={() => this.poster} />
          </ModalFooter>
        </Modal>
      </PageShell>
    );
  }
}

export default Membership;
